<template>
  <div class="search-list">
    <div class="search-list-inner">
      <div class="firstChild">Search results</div>
      <div class="search-list-table">
        <h3 v-if="isPagination">lncRNA results
          <i class="el-icon-download" @click="downloadSelect"> Download selected</i>
          <i class="el-icon-download" @click="DownloadAll"> Download all</i>
          <el-radio-group v-if="isPagination" v-model="radioType" style="float:right;margin-top:8px;">
            <el-radio label="gff">GFF</el-radio>
            <el-radio label="fasta">FASTA</el-radio>
            <el-radio label="csv">CSV</el-radio>
          </el-radio-group>
        </h3>
        <el-table :data="tableData" class="table" v-loading="loading" ref="multipleTable" stripe header-cell-class-name="table-header"
          :header-cell-style="headerStyle" :row-style="rowStyle" :row-class-name="tableRowClassName" @cell-click="handlecell"
          @selection-change="handleSelectionChange" :cell-style="cellstyle">
          >
          <el-table-column v-for="(item, index) in tableDataItem" :width="item.width" :key="index" :prop="item.prop" align="center"
            :show-overflow-tooltip="true" :label="item.label">
          </el-table-column>
          <el-table-column label="PLEK/CPC/RNAplonc/CREMA" width="256" align="center" v-if="isPagination">
            <template slot-scope="scope">
              <el-rate style="display: inline-block;" v-model="scope.row.source == 'PLncDB' ? 1 : scope.row.PLEK" disabled :max="1"></el-rate>
              <el-rate style="display: inline-block;" v-model="scope.row.source == 'PLncDB' ? 1 : scope.row.cpc" disabled :max="1"></el-rate>
              <el-rate style="display: inline-block;" v-model="scope.row.rna_plonc" disabled :max="1"></el-rate>
              <el-rate style="display: inline-block;" v-model="scope.row.crema" disabled :max="1"></el-rate>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="55" v-if="isPagination">
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="isPagination">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
            :page-sizes="[10, 20, 30, 50]" :page-size="query.size" layout="total, sizes, prev, pager, next" :total="pageTotal">
          </el-pagination>
        </div>
        <h3 v-if="isPagination">Gene results
          <i class="el-icon-download" @click="genedownloadSelect"> Download selected</i>
          <i class="el-icon-download" @click="geneDownloadAll"> Download all</i>
          <el-radio-group v-if="isPagination" v-model="geneRadioType" style="float:right;margin-top:8px;">
            <el-radio label="fasta">FASTA</el-radio>
            <el-radio label="csv">CSV</el-radio>
          </el-radio-group>
        </h3>
        <el-table v-if="isPagination" :data="tableData_gene" class="table" v-loading="loading_gene" ref="multipleTable" stripe header-cell-class-name="table-header"
          @selection-change="geneSelectionChange" :header-cell-style="headerStyle" :row-style="rowStyle" :row-class-name="tableRowClassName"
          @cell-click="handlecell_gene" :cell-style="cellstyle_gene">
          >
          <el-table-column v-for="(item, index) in tableDataItem_gene" :width="item.width" :key="index" :prop="item.prop" align="center"
            :show-overflow-tooltip="true" :label="item.label">
          </el-table-column>
          <el-table-column type="selection" width="55">
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="isPagination">
          <el-pagination background @size-change="handleSizeChange_gene" @current-change="handleCurrentChange_gene" :current-page="query_gene.page"
            :page-sizes="[10, 20, 30, 50]" :page-size="query_gene.size" layout="total, sizes, prev, pager, next" :total="pageTotal_gene">
          </el-pagination>
        </div>
      </div>
      <div v-if="!isPagination" style="margin-top:20px;">
        <dl class="ruler_dl">
          <dt>{{titleH1}}</dt>
          <dd>
            <div class='ruler'>
              <div class='cm' v-for="(items, indexs) in itemCm" :v-for="indexs">
                <div class='mm' v-for="(item, index) in 4" :key="index"></div>
                <span>{{items}}</span>
              </div>
              <div class='cm'>
                <span>{{alignLength}}</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl class="ruler_dl ruler_dl1" v-for="(item, index) in itemContent" :key="index">
          <dt>{{item.hits}}</dt>
          <dd v-if="(Number(item.score) > 0 && Number(item.score) < 50) || Number(item.score) == 50 " style="background:#305DB7;"></dd>
          <dd v-if="(Number(item.score) > 50 && Number(item.score) < 100) || Number(item.score) == 100" style="background:#868BA3;"></dd>
          <dd v-if="(Number(item.score) > 100 && Number(item.score) < 150) || Number(item.score) == 150" style="background:#C59C49;"></dd>
          <dd v-if="(Number(item.score) > 150 && Number(item.score) < 200) || Number(item.score) == 200" style="background:#3B9C25;"></dd>
          <dd v-if="Number(item.score) > 200" style="background:#BC423B;"></dd>
        </dl>
        <dl class="ruler_dl" style="margin-top:30px;">
          <dt>{{titleH1}}</dt>
          <dd>
            <div class='ruler ruler1'>
              <div class='cm' v-for="(items, indexs) in itemCm" :key="indexs">
                <div class='mm' v-for="(item, index) in 4" :key="index"></div>
                <span>{{items}}</span>
              </div>
              <div class='cm'>
                <span>{{alignLength}}</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl class="ruler_dl ruler_dl3">
          <dt>Scoring <br />colors</dt>
          <dd>
            <ul>
              <li style="background:#305DB7;"></li>
              <li style="background:#868BA3;"></li>
              <li style="background:#C59C49;"></li>
              <li style="background:#3B9C25;"></li>
              <li style="background:#BC423B;"></li>
            </ul>
            <ul style="margin-top:5px;">
              <li>S>0</li>
              <li>S>50</li>
              <li>S>100</li>
              <li>S>150</li>
              <li>S>200</li>
            </ul>
          </dd>
        </dl>
        <div v-for="(item, index) in itemsBottom" :key="item.hits" style="color:#666;font-size:14px;">
          <p class="bottom_p">
            >{{item.hits}}
          </p>
          <p class="bottom_p">
            Score = {{item.score1}} bits ({{item.bits1}})， Expect = {{item.Expect1}},Method: Compositional matrix adjus
          </p>
          <p>Identities = {{item.IdentitiesFz}}/{{item.IdentitiesFm}}({{item.IdentitiesBfb}}%)，Positives= {{item.PositivesFz}}/{{item.PositivesFm}}({{item.PositivesBfb}}%)</p>
          <div v-for="(que_sbj, idx) in querySbjct" :key="idx">
            <p class="bottom_p">
              <span v-html="que_sbj.query"></span>
            </p>
            <p style="margin-left: 3em;">
              <span v-html="que_sbj.match"></span>
            </p>
            <p class="bottom_p">
              <span v-html="que_sbj.sbjct"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let url = {
  species: "species/search_key_word",
  location: "species/search_genomic_location",
  expression: "species/search_expression",
  genes: "species/search_target_genes"
};
import { tableDataItem1, tableDataItem3, tableDataItem1_gene } from './config'
export default {
  data() {
    return {
      tableDataItem: [],
      tableDataItem_gene: [],
      tableDataItem1,
      tableDataItem1_gene,
      tableDataItem3,
      tableData: [],
      tableData_gene: [],
      pageTotal: 0,
      pageTotal_gene: 0,
      query: {
        page: 1,
        size: 10
      },
      query_gene: {
        page: 1,
        size: 10
      },
      headerStyle: {
        background: "#F5F9FC",
        fontSize: "16px",
        fontFamily: "PingFang SC",
        fontWeight: "bold",
        color: "#333"
      },
      rowStyle: {
        fontSize: "14px",
        fontFamily: "PingFang SC",
        fontWeight: "400",
        color: "#666"
      },
      loading: false,
      loading_gene: false,
      isPagination: true,
      itemCm: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      itemContent: [],
      str: '',
      titleH1: '',
      alignLength: 0,
      itemsBottom: [],
      querySbjct: [],
      lncRNA_ids: [],
      isoform_id: [],
      value1: 2,
      radioType: 'csv',
      geneRadioType: 'csv'
    };
  },
  created() {
    this.getData();
    this.getData_gene();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getData() {
      let tableParams = JSON.parse(sessionStorage.getItem("tableParams"))
      let params = Object.assign({}, tableParams.params, this.query)
      this.loading = true
      if (tableParams.types == 3) {
        this.isPagination = false
        this.loading = false
        this.tableDataItem = this.tableDataItem3;
        this.tableData = JSON.parse(sessionStorage.getItem("tableParams3"))
        this.titleH1 = this.tableData && this.tableData[0] && this.tableData[0].query_id || ''
        this.itemContent = this.tableData
        this.itemsBottom = JSON.parse(JSON.stringify(this.tableData));
        this.itemCm = []
        for (let i = 0; i < 10; i++) {
          this.itemCm.push(`${Math.floor(this.tableData[0].align_length / 10) * i}`)
        }
        this.alignLength = this.tableData[0].align_length
        this.itemsBottom.forEach(item => {
          item.score1 = item.bits
          item.bits1 = item.alignment_length
          item.Expect1 = item.expect
          item.IdentitiesFz = item.identities
          item.IdentitiesFm = item.align_length
          item.IdentitiesBfb = (Number(item.identities) / Number(item.align_length)).toFixed(2) * 100
          item.PositivesFz = item.positives
          item.PositivesFm = item.align_length
          item.PositivesBfb = (Number(item.positives) / Number(item.align_length)).toFixed(2) * 100
          this.querySbjct = []
          for (let i = 0; i < Math.ceil(item.query.length / 60); i++) {
            this.querySbjct.push({
              query: `<span style="display:inline-block;width:90px;">Query:${Number(1) + i * 60}</span>` + item.query.substr(i * 60, 60) + `<span style="display:inline-block;padding-left:10px;">${i < Math.ceil(item.query.length / 60) - 1 ? (i + 1) * 60 : item.query.length}</span><br />`,
              // match: `${item.match} <br />`,
              sbjct: `<span style="display:inline-block;width:90px;">Sbjct:${Number(1) + i * 60}</span>` + item.sbjct.substr(i * 60, 60) + `<span style="display:inline-block;padding-left:10px;">${i < Math.ceil(item.query.length / 60) - 1 ? (i + 1) * 60 : item.query.length}</span><br />`,
            })
          }
          // for (let i = 0; i < Math.ceil(item.sbjct.length / 60); i++) {
          // }
        })
      } else {
        this.isPagination = true
        this.http.get(tableParams.urls, params).then(res => {
          if (res.data.code == 200) {
            if (tableParams.types == 1) {
              this.tableDataItem = this.tableDataItem1;
            }
            this.loading = false
            this.tableData = res.data.data
            this.pageTotal = res.data.count;
          }
        }).catch(err => {
          this.$message.warning(err.response.data.error.message);
        });
      }
    },
    getData_gene() {
      let tableParams = JSON.parse(sessionStorage.getItem("tableParams"))
      let params = Object.assign({}, tableParams.params, this.query_gene)
      this.loading_gene = true
      if (tableParams.types == 1) {
        this.isPagination_gene = true
        this.http.get(tableParams.urls2, params).then(res => {
          if (res.data.code == 200) {
            if (tableParams.types == 1) {
              this.tableDataItem_gene = this.tableDataItem1_gene;
            }
            this.loading_gene = false
            this.tableData_gene = res.data.data
            this.pageTotal_gene = res.data.count;
          }
        }).catch(err => {
          this.$message.warning(err.response.data.error.message);
        });
      }
    },
    handlecell(row, col) {
      if (col.label === "lncRNA ID") {
        sessionStorage.removeItem("lncRNA_id");
        sessionStorage.setItem("lncRNA_id", row.lncRNA_id);
        // this.$router.push("/nunMir");
        this.$router.push({
          path: '/nunMir',
          query: {
            plncdb_id: row.lncRNA_id
          }
        })
      } else if (col.label === "Subject") {
        if (row.lnc_or_isform == 'isform') {
          sessionStorage.removeItem("isoform_id");
          sessionStorage.setItem("isoform_id", row.hit_id);
          this.$router.push("/nunMirGene");
        } else {
          sessionStorage.removeItem("lncRNA_id");
          sessionStorage.setItem("lncRNA_id", row.hit_id);
          // this.$router.push("/nunMir");
          this.$router.push({
            path: '/nunMir',
            query: {
              plncdb_id: row.hit_id
            }
          })
        }
      }
    },
    handlecell_gene(row, col) {
      if (col.label === "Gene Model") {
        sessionStorage.removeItem("isoform_id");
        sessionStorage.setItem("isoform_id", row.isoform_id);
        this.$router.push("/nunMirGene");
      }
    },
    cellstyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return { color: "#3366CC", cursor: "pointer" };
        // return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      }
      if (column.label === 'Species') {
        return {
          fontStyle: 'italic'
        }
      }
    },
    cellstyle_gene({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return { color: "#3366CC", cursor: "pointer" };
        // return { color: '#3366CC', cursor: 'pointer', textDecoration: 'underline' }
      }
      if (column.label === 'Species') {
        return {
          fontStyle: 'italic'
        }
      }
    },
    handleSizeChange(val) {
      this.query.page = 1
      this.query.size = val
      this.getData()

    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getData()
    },
    handleSizeChange_gene(val) {
      this.query_gene.page = 1
      this.query_gene.size = val
      this.getData_gene()

    },
    handleCurrentChange_gene(val) {
      this.query_gene.page = val
      this.getData_gene()
    },
    handleSelectionChange(val) {
      this.lncRNA_ids = []
      val.forEach(item => {
        this.lncRNA_ids.push(item.lncRNA_id)
      });
    },
    downloadSelect() {
      if (this.lncRNA_ids.length < 1) {
        this.$message('Please select the columns to download！')
        return
      }
      const param = {
        lncRNA_id: this.lncRNA_ids.join(','),
        validate: '',
        specie: JSON.parse(sessionStorage.getItem("tableParams")).params.specie_name,
        download_type: this.radioType
      }
      this.jg_downloadFile(this.radioType == 'gff' ? 'efp/gff_download' : 'species/download_lncrna_result', param)
    },
    DownloadAll() {
      const param = {
        lncRNA_id: '',
        validate: '',
        specie: JSON.parse(sessionStorage.getItem("tableParams")).params.specie_name,
        download_type: this.radioType,
        search: JSON.parse(sessionStorage.getItem("tableParams")).params.search
      }
      this.jg_downloadFile(this.radioType == 'gff' ? 'efp/gff_download' : 'species/download_lncrna_result', param)
    },
    geneSelectionChange(val) {
      this.isoform_id = []
      val.forEach(item => {
        this.isoform_id.push(item.isoform_id)
      });
    },
    genedownloadSelect() {
      if (this.isoform_id.length < 1) {
        this.$message('Please select the columns to download！')
        return
      }
      const param = {
        isoform_ids: this.isoform_id.join(','),
        specie: JSON.parse(sessionStorage.getItem("tableParams")).params.specie_name,
        download_type: this.geneRadioType
      }
      this.jg_downloadFile('species/download_gene_result', param)
    },
    geneDownloadAll() {
      const param = {
        isoform_ids: '',
        specie: JSON.parse(sessionStorage.getItem("tableParams")).params.specie_name,
        download_type: this.geneRadioType
      }
      this.jg_downloadFile('species/download_gene_result', param)
    }
  }
};
</script>

<style scoped>
@import "./style.css";
</style>
